import { createRealtimeEventBus } from '@src/shared/realtime';

/** Topic on the shared application socket, matching TASK_SUMMARY_TOPIC in
 * apps/task_management/services/summary_events.py. */
export const TASK_SUMMARY_TOPIC = 'tasks.summary';

/**
 * Raised when the bridge cannot say what changed, only that something might
 * have: reconnecting and returning to a backgrounded tab mean messages went
 * out while nobody was listening, and midnight means nothing was sent at all
 * but every task's urgency moved anyway. Lists have to go and ask again.
 *
 * Carries no `taskId`, which is also why the task page's per-row sync ignores
 * it and syncs on the reasons it knows instead.
 */
export const TASK_RESYNC_REASON = 'tasks.resync';

export type TaskSummaryChangedEvent = {
  reason: string;
  taskId?: number;
  changeReason?: string;
};

const taskRealtimeEventBus = createRealtimeEventBus<TaskSummaryChangedEvent>();

export function publishTaskRealtimeEvent(event: TaskSummaryChangedEvent) {
  taskRealtimeEventBus.publish(event);
}

export function subscribeToTaskRealtimeEvents(
  listener: (event: TaskSummaryChangedEvent) => void,
) {
  return taskRealtimeEventBus.subscribe(listener);
}
